import type { SupportedLanguage } from './types';

/**
 * Maps non-canonical hyphenated locale codes to their canonical SupportedLanguage.
 * Used by getSafeLanguage and other locale-normalization utilities.
 *
 * Keys are lowercased for case-insensitive lookup.
 */
export const REGIONALIZED_LOCALE_MAP: Record<string, SupportedLanguage> = {
  'zh-cn': 'zh-hans',
  'zh-hk': 'zh-hant',
  'zh-hans': 'zh-hans',
  'zh-hant': 'zh-hant',
  'zh-hans-cn': 'zh-hans',
  'zh-hant-hk': 'zh-hant',
  'en-gb': 'en-gb',
};

/**
 * Maps underscore-delimited locale codes (e.g. from CMS data) to their
 * canonical SupportedLanguage. Kept separate from REGIONALIZED_LOCALE_MAP
 * since these originate from a different source format.
 *
 * Keys are lowercased for case-insensitive lookup.
 */
export const UNDERSCORE_LOCALE_MAP: Record<string, SupportedLanguage> = {
  en_gb: 'en-gb',
  zh_cn: 'zh-hans',
  zh_hk: 'zh-hant',
};
